// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EwryT-BankListState-module_root{display:flex;flex-grow:1;flex-direction:column}.Gg8ij-BankListState-module_title{margin-bottom:1.3333333333rem}.fYNyY-BankListState-module_cell+.fYNyY-BankListState-module_cell{margin-top:1.3333333333rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "EwryT-BankListState-module_root",
	"title": "Gg8ij-BankListState-module_title",
	"cell": "fYNyY-BankListState-module_cell"
};
export default ___CSS_LOADER_EXPORT___;
